import Types from "./Types";

const INITIAL_STATE = {
  lastLiveVideo: null,
  enabled: true,
  isLoading: false,
};

export default function studentLiveVideos(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_STUDENT_LAST_LIVE_VIDEO_SUCCESS: {
      return {
        ...state,
        lastLiveVideo: payload.data,
        enabled: payload.enabled ?? true,
      };
    }

    case Types.SAVE_STUDENT_LIVE_VIDEO_SEEN_SUCCESS: {
      return {
        ...state,
        lastLiveVideo: payload.data,
      };
    }

    case Types.STUDENT_LIVE_VIDEOS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    default: {
      return state;
    }
  }
} 